import React, { useEffect } from 'react'
import { useVideoPlayerData } from '../VideoPlayer/VideoPlayerContext'
import PassportBadge from '../PassportBadge'
import {
  useFocusable,
  setFocus,
} from '@noriginmedia/norigin-spatial-navigation'
import FocusableButtonTS from '../FocusableButton/FocusableButtonTS'
import type { ContinueWatchingModalProps } from './types'
import { AUTO_DISMISS_DURATION_MS } from './types'

const ContinueWatchingModal = ({
  handleContinueWatchingNavigation,
}: ContinueWatchingModalProps) => {
  const autoDismissModalTimeoutId = React.useRef<NodeJS.Timeout | null>(null)
  const { playerStateRef } = useVideoPlayerData()
  const { ref } = useFocusable()

  const startAutoDestructionTimer = () => {
    autoDismissModalTimeoutId.current = setTimeout(() => {
      handleContinueWatchingNavigation(false)
    }, AUTO_DISMISS_DURATION_MS)
  }

  useEffect(() => {
    startAutoDestructionTimer()
    setFocus('continue-watching-action')

    return () => {
      if (autoDismissModalTimeoutId.current) {
        clearTimeout(autoDismissModalTimeoutId.current)
      }
    }
  }, [])

  return (
    <div className="continue-watching-modal__container" ref={ref}>
      <div className="up-next-text-button-container">
        <h1>Are you still watching?</h1>
        <FocusableButtonTS
          focusKey="continue-watching-action"
          onEnterPress={() => handleContinueWatchingNavigation(true)}
        >
          Continue Watching
        </FocusableButtonTS>
        <FocusableButtonTS
          focusKey="back-button-action"
          onEnterPress={() => handleContinueWatchingNavigation(false)}
        >
          Back
        </FocusableButtonTS>
      </div>
      <div className="up-next-continue-watching-overlay"></div>
      {playerStateRef.current.upNextData?.isMvod && (
        <PassportBadge sizePx={80} />
      )}
      <img
        src={playerStateRef.current.upNextData?.upNextImage}
        className="up-next-image"
      />
    </div>
  )
}

export default ContinueWatchingModal
